import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import { isEmptyArray } from '../../../common/Global/commonFunctions';

class FrameworkClauseInfoDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }
    }

    componentDidUpdate(prevProps){
        if(JSON.stringify(prevProps) !== JSON.stringify(this.props) && this.props.showFrameworkClauseInfoDialog){
        }
    }

    render(){
        let displayPlaceholder = `${this.props.framworkClaueItem.frameworkClauseName}<p style="white-space:nowrap;margin-top: "2px";">&nbsp;:&nbsp;</p>${this.props.framworkClaueItem.frameworkClauseHeading}`;
        return(
            <Modal className="custom-dialog"
            show={this.props.showFrameworkClauseInfoDialog} onHide={this.props.handleFrameworkClauseDialogClose} backdrop="static">
                <Modal.Header>
                    <h5>{this.props.frameworkName}</h5>
                    <button 
                        onClick={this.props.handleFrameworkClauseDialogClose}
                        type="button" data-dismiss="modal">
                        <span class="material-icons">close</span>
                    </button>
                </Modal.Header>
                <hr />
                <div className="modal-body">
                    <div className="body-wrapper">
                        {
                            !isEmptyArray(Object.keys(this.props.framworkClaueItem)) && 
                            <div className="details-table-layout">
                                <div className="dialog-tree-structure-sync mt-0">
                                    <p 
                                        style={{color:this.props.fontColor,marginTop:this.props.paraMT?this.props.paraMT:0, marginBottom:3}}
                                        className='task-dangerouslysethtml framework-inline inner-html d-flex'
                                        dangerouslySetInnerHTML={{__html: displayPlaceholder}}>
                                    </p>
                                    <div style={{
                                        marginTop:4,
                                        marginBottom:12,
                                        whiteSpace: "normal",
                                        wordBreak: "break-word",
                                        overflow: "visible",
                                    }}
                                    className='task-dangerouslysethtml inner-html' 
                                    dangerouslySetInnerHTML={{__html: this.props.framworkClaueItem.frameworkClauseDescription}} />
                                </div>
                            </div>
                        }
                    </div>
                </div>
            </Modal>
        )
    }
}
export default FrameworkClauseInfoDialog;